<template>
	<div class="shared-foldable">
		<div
			class="shared-foldable__header"
			@click="setup.isOpen = !setup.isOpen">
			<div class="shared-foldable__toggle">
				<div
					v-if="icon || fontIcon"
					class="shared-foldable__icon">
					<o-icon
						v-if="icon || fontIcon"
						:icon="icon"
						:font-icon="fontIcon"/>
				</div>
				<o-icon
					class="shared-foldable__chevron"
					:icon="setup.isOpen ? 'chevron_down' : 'chevron_right'"/>
			</div>
			<slot
				name="header"
				v-bind="{ isOpen: setup.isOpen }"/>
		</div>

		<div
			v-if="setup.isOpen"
			class="shared-foldable__content">
			<slot v-bind="{ isOpen: setup.isOpen }"/>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedFoldableEmits, SharedFoldableProps } from './SharedFoldableSetup';
import SharedFoldableSetup from './SharedFoldableSetup';
const emits = defineEmits<SharedFoldableEmits>() as SharedFoldableEmits;
const props = withDefaults(defineProps<SharedFoldableProps>(), SharedFoldableSetup.defaultProps);
const setup = new SharedFoldableSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins.less";
@import "@/styles/variables.less";

.shared-foldable {
	// background: transparent;
	&__header {
		cursor: pointer;
		position: relative;
		display: flex;
		gap: 0.5rem;
		align-items: center;
		width: 100%;

		&::before {
			content: "";
			position: absolute;
			z-index: -1;
			inset: 0;
			display: block;
			margin: -0.5rem;
			border-radius: 0.5rem;
			transition: 0.3s background-color;
		}

		/* &:hover {
      background-color:rgba(var(--rgb-grey-darker), 0.05);
    } */

		&:hover::before {
			background-color: rgba(var(--rgb-grey-darker), 0.05);
		}

		> :not(.shared-foldable__toggle) {
			flex: 1;
		}
	}

	&__toggle {
		display: flex;
		gap: 0.5rem;
		align-items: center;
	}

	&__icon {
		--color: v-bind("setup.rgbColor");
		.square(2.5rem);
		.flex-align();

		border-radius: 0.25rem;
		color: rgb(var(--color));
		background-color: white;
		/* stylelint-disable-next-line function-no-unknown, declaration-property-value-no-unknown */
		box-shadow: 0 2px 4px fade(black, 5);

		.orion-icon {
			font-size: 1.25rem;
		}
	}

	&__chevron {
		font-size: 1.5rem;
	}

	&__content {
		margin-top: 1rem;
	}
}
</style>
